import { controls, grouped } from "../controls";
const inspection_observations = {
  label: "Inspection Observations",
  pageLabel: "Inspection Observations", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Recompliance", uid: "recompliance", fastpath: "recompliances" },
      { label: "Acceptance", uid: "acceptance", fastpath: "acceptances" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "InspectionObservation-inspection-client-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "InspectionObservation-inspection-client-client_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "InspectionObservation-inspection-branch-branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "InspectionObservation-inspection-branch-branch_display" }),
  ]
  , form: [
    ...controls.showData({ tab: "general", displaytype: "capital", data: "inspection_observation_type_display", width: "col-sm-10", style: { marginBottom: 5 }, dheight: 'multiline', prepend: 1 }),
    ...controls.autoComplete({ tab: "general", name: "inspection_status_code", width: "col-sm-2", controlType: "InspectionStatus", width: "col-sm-2", isRequired: true }),
    ...controls.text({ tab: "general", placeHolder: "Remarks", name: "remark", width: "col-sm-4", maxlength: 500, width: "col-sm-8", isRequired: true }),
    ...controls.magicDateLabel({ tab: "general", label: "Complete By", target: "complete_by", star: false, parents: [{ "name": "inspection_status_code", "match": "in", "value": ["Incomplete", "In Progress", "Not Started", "NO"] }] }),
    ...controls.magicDate({ tab: "general", name: "complete_by", dateType: "ontype", parents: [{ "name": "inspection_status_code", "match": "in", "value": ["Incomplete", "In Progress", "Not Started", "NO"] }], minDate: 'n', maxDate: '1 months from now', isRequired: true }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "recompliance", label: "Note", star: true }),
    ...controls.text({ tab: "recompliance", placeHolder: "", isRequired: true, name: "recompliance.note", width: "col-sm-4", maxlength: 200 }),

    ...controls.displayText({ tab: "recompliance", label: "Rejection Remark", star: false }),
    ...controls.text({ tab: "recompliance", placeHolder: "", isReadOnly: true, name: "recompliance.rejection_remark", width: "col-sm-4" }),
    {
      widths: "col-sm-12",
      tab: "recompliance",
      title: "Recompliance Items",
      subComponents: [
        ...controls.displayText({ tab: "recompliance", label: "Document Type", star: false }),
        ...controls.text({ tab: "recompliance", placeHolder: "", name: "document_type", maxlength: 50 }),
        ...controls.displayText({ tab: "recompliance", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "recompliance", label: "Document Description", star: false }),
        ...controls.text({ tab: "recompliance", placeHolder: "", name: "document_description", width: "col-sm-4", maxlength: 200 }),
        ...controls.displayText({ tab: "recompliance", label: "Upload Document", star: false }),
        ...controls.FileUpload({ tab: "recompliance", width: "col-sm-4", name: "document_url" }),
        ...controls.displayText({ tab: "recompliance", label: "Recompliance Remark", star: false }),
        ...controls.text({ tab: "recompliance", placeHolder: "", name: "recompliance_remark", width: "col-sm-4", maxlength: 500 }),

        ...controls.displayText({ tab: "recompliance_items", width: "col-sm-12", label: "" }),
        ...controls.displayText({ tab: "recompliance_items", width: "col-sm-4", label: "" }),
        ...controls.button({
          tab: "recompliance_items",
          label: "ADD",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "appendToHTMLTable",
            tableNameField: "recompliance_items",
            requiredField: ["document_type", "document_description", "document_url", "recompliance_remark",]
          }, width: "col-sm-2"
        }),
        ...controls.button({
          tab: "recompliance_items",
          label: "CLEAR",
          style: { padding: 0 },
          Bcolor: "warning",
          onclick: {
            action: "clearForm",
            tableNameField: "recompliance_items",
            requiredField: ["document_type", "document_description", "document_url", "recompliance_remark",]
          }, width: "col-sm-2"
        }),
        {
          tab: "recompliance_items",
          inputType: "table",
          tableTitle: "",
          deletable: true,
          editable: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Document Type", field: "document_type" },
            { label: "Document Description", field: "document_description" },
            { label: "Document Url", field: "document_url", displaytype: "file" },
            { label: "Recompliance Remark", field: "recompliance_remark" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "recompliance_items"
        },
      ]
    },
    ...controls.displayText({ tab: "acceptance", label: "Acceptance Status", star: false }),
    ...controls.autoComplete({ tab: "acceptance", name: "acceptance.acceptance_status_code", width: "col-sm-2", controlType: "AcceptanceStatus" }),
    ...controls.displayText({ tab: "acceptance", label: "" }),
    ...controls.displayText({ tab: "acceptance", label: "Acceptance Remark", star: false, parents: [{ "name": "acceptance.acceptance_status_code", "match": "in", "value": ["accept"] }] }),
    ...controls.text({ tab: "acceptance", placeHolder: "", name: "acceptance.acceptance_remark", width: "col-sm-4", maxlength: 200, parents: [{ "name": "acceptance.acceptance_status_code", "match": "in", "value": ["accept"] }] }),
    ...controls.displayText({ tab: "acceptance", label: "Rejection Remark", star: false, parents: [{ "name": "acceptance.acceptance_status_code", "match": "in", "value": ["reject"] }] }),
    ...controls.text({ tab: "acceptance", placeHolder: "", name: "acceptance.rejection_remark", width: "col-sm-4", maxlength: 200, parents: [{ "name": "acceptance.acceptance_status_code", "match": "in", "value": ["reject"] }], isRequired: true }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Inspection Observations",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Client", accessor: "InspectionObservation-client-client_display", },
      { Header: "Branch", accessor: "InspectionObservation-inspection-branch-branch_display", },
      { Header: "Remark", accessor: "remark", },
      { Header: "Updatedat", accessor: "updatedat", type: 'date' },
    ]
  }
};
export default inspection_observations;